module.exports = __webpack_public_path__ + "img/hardware_mode.b102a297.svg";